import { Modal as MuiModal, Box, Typography, Button, CircularProgress } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import WarningIcon from '@mui/icons-material/Warning';

interface ModalUnblockProps {
    open: boolean;
    onClose: () => void;
    onConfirm: () => void;
    loading: boolean;
    title?: string;
    description?: string;
    confirmText?: string;
    lockerName?: string;
}

export function ModalUnblock({ 
    open, 
    onClose, 
    onConfirm, 
    loading, 
    title = "Confirmar disponibilização",
    description,
    confirmText = "Disponibilizar",
    lockerName
}: ModalUnblockProps) {
    const defaultDescription = lockerName 
        ? `Tem certeza que deseja disponibilizar o armário ${lockerName}?<br />Este armário ficará disponível para novas reservas.`
        : "Tem certeza que deseja disponibilizar este armário?<br />Este armário ficará disponível para novas reservas.";

    return (
        <MuiModal
            open={open}
            onClose={onClose}
            aria-labelledby="modal-unblock-title"
            aria-describedby="modal-unblock-description"
        >
            <Box
                sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    bgcolor: 'background.paper',
                    borderRadius: 3,
                    boxShadow: 24,
                    p: 4,
                    minWidth: 490,
                    maxWidth: '100vw',
                    outline: 'none',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                }}
            >
                <Box
                    sx={{
                        background: '#ECFDF3',
                        borderRadius: '50%',
                        width: 56,
                        height: 56,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        mb: 2,
                    }}
                >
                    <CheckCircleIcon sx={{ color: '#17B26A', fontSize: 32 }} />
                </Box>
                <Typography
                    id="modal-unblock-title"
                    sx={{
                        fontWeight: 600,
                        fontSize: 18,
                        color: '#101828',
                        mb: 1,
                        textAlign: 'center',
                    }}
                >
                    {title}
                </Typography>
                <Typography
                    id="modal-unblock-description"
                    sx={{
                        color: '#344054',
                        fontSize: 15,
                        textAlign: 'center',
                        mb: 3,
                    }}
                    dangerouslySetInnerHTML={{ __html: description || defaultDescription }}
                />
                <Box sx={{ display: 'flex', gap: 2, width: '100%', mt: 1 }}>
                    <Button
                        variant="outlined"
                        onClick={onClose}
                        disabled={loading}
                        sx={{
                            flex: 1,
                            bgcolor: '#F9FAFB',
                            color: '#344054',
                            borderColor: '#F2F4F7',
                            borderRadius: 2,
                            fontWeight: 600,
                            fontSize: 15,
                            boxShadow: 'none',
                            '&:hover': { bgcolor: '#F2F4F7', borderColor: '#F2F4F7' },
                        }}
                    >
                        Cancelar
                    </Button>
                    <Button
                        variant="contained"
                        onClick={onConfirm}
                        disabled={loading}
                        startIcon={<CheckCircleIcon />}
                        sx={{
                            flex: 1,
                            bgcolor: '#17B26A',
                            color: '#fff',
                            borderRadius: 2,
                            fontWeight: 600,
                            fontSize: 15,
                            boxShadow: 'none',
                            '&:hover': { bgcolor: '#16A262' },
                        }}
                    >
                        {loading ? <CircularProgress size={22} color="inherit" /> : confirmText}
                    </Button>
                </Box>
            </Box>
        </MuiModal>
    );
}
